import React, { useState, useEffect, useCallback } from "react";
import axios from 'axios';

import { Swiper, SwiperSlide } from 'swiper/react';
import { Navigation, Pagination, Autoplay, EffectFade } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import "swiper/css/effect-fade";
import { Link } from 'react-router-dom';
import Preloader from '../Preloader';

const MainSlider = () => {

  const apiBaseUrl = process.env.REACT_APP_API_BASE_URL;
  const apiUrl = apiBaseUrl+`home-slider`;
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true)

  useEffect(() => {
    const fetchPagedata = async () => {
        setLoading(true);
        try {
            const [sliderRes] = await Promise.all([
            axios.get(apiUrl),
             ]);
            setData(sliderRes.data);
        } catch (error) {
            console.error("Error fetching data:", error);
        };
        setLoading(false);
    }
    fetchPagedata();
  }, []);      

  return (
    <>
    { loading && <Preloader />}
    <Swiper
      className="main-slider-one"
      modules={[Navigation, Pagination, Autoplay, EffectFade]}
      spaceBetween={0}
      slidesPerView={1}
      navigation
      pagination={{ clickable: true }}
      autoplay={{ delay:6000 }}
      loop={true}
      effect="fade"
      fadeEffect= {{ crossFade: false }}
      onSwiper={(swiper) => console.log(swiper)}
    >
    { data.map(( item, index) => {
        return(
        <SwiperSlide key={index}>
            <div className="item">
                <div className="main-slider-one__item">
                    <div className="main-slider-one__bg" style={{ backgroundImage: 'url(assets/images/backgrounds/slider-1-1.png)' }}></div>
                    <div className="main-slider-one__shape-one" style={{ backgroundImage: 'url(assets/images/shapes/slider-1-shape-1.png)' }}></div>
                    <div className="main-slider-one__shape-two">
                        <img src="assets/images/shapes/slider-1-shape-2.png" alt="growim" />
                    </div>
                    <div className="main-slider-one__shape-three">
                        <img src="assets/images/shapes/slider-1-shape-3.png" alt="growim" />
                    </div>
                    <div className="main-slider-one__shape-four">
                        <img src="assets/images/shapes/slider-1-shape-4.png" alt="growim" />
                    </div>
                    <div className="main-slider-one__shape-five">
                        <img src="assets/images/shapes/slider-1-shape-5.png" alt="growim" />
                    </div>
                    <div className="main-slider-one__shape-six">
                        <img src="assets/images/shapes/slider-1-shape-6.png" alt="growim" />
                    </div>
                    <div className="main-slider-one__shape-six">
                        <img src="assets/images/shapes/slider-1-shape-6.png" alt="growim" />
                    </div>
                    <div className="main-slider-one__shape-seven">
                        <img src="assets/images/shapes/slider-1-shape-7.png" alt="growim" />
                    </div>
                    <div className="main-slider-one__report">
                        <p className="main-slider-one__report__text">{ item?.tagline }</p>
                        <h5 className="main-slider-one__report__number">{ item?.focusline }</h5>
                    </div>
                    <div className="main-slider-one__content">
                        <h5 className="main-slider-one__sub-title">{ item?.name }</h5>

                        <h2 className="main-slider-one__title">{ item?.white_text } <span style={{ color: "#ff6701" }}>{ item?.color_text }</span></h2>
                        <p className="main-slider-one__text" dangerouslySetInnerHTML={{ __html: item?.description }} />
                        <div className="main-slider-one__btn">
                            <Link className="growim-btn growim-btn--white" to="/services">
                                <span className="growim-btn__text">view services</span>
                                <span className="growim-btn__icon"><i className="flaticon-up-right-arrow"></i></span>
                            </Link>
                        </div>
                    </div>
                </div>
            </div>
        </SwiperSlide>
        )
    })}
    </Swiper>
    </>
  )
}

export default MainSlider